'use client';

// Third Party Plugins
import React from 'react';
// Types
import { Resource } from '../../types';
import { ResourceListProps } from './types';
// Custom Components
import MediumCard from '@/components/cards/MediumCard';
import ImageContainer from '@/components/images/ImageContainer';
import DefaultThumbnailImage from '@/components/images/DefaultThumbnailImage';
import CardGridContainer from '@/components/cards/CardGridContainer';

const ResourceList: React.FC<ResourceListProps> = ({ resources }) => {
  return (
    <CardGridContainer>
      {resources.map((r: Resource) => (
        <MediumCard
          _id={r._id}
          cardType={r.resourceType}
          key={r._id}
          title={r.resourceBlockHeading}
          description={r.resourceDescription}
          href={r.callToActionLink}
          image={
            r.resourceImageBlock?.asset?.url ? (
              <ImageContainer
                image={r.resourceImageBlock.asset.url}
                width={282}
                height={134}
                type="dynamic"
                alt={r.resourceImageBlock.alt}
              />
            ) : (
              <DefaultThumbnailImage
                height={134}
                width={282}
                borderRadius="var(--radius-md)"
              />
            )
          }
        />
      ))}
    </CardGridContainer>
  );
};

export default ResourceList;
